<template>
  <div class="payment-instructions">
    <v-container>
      <v-row
        class="ma-0"
        v-for="(crypto, index) in crypto_currency_wallet"
        :key="index"
      >
        <v-col cols="12" class="text-center"
          ><h3 style="color: #434343" class="mb-5 mt-4">
            Crypto Currency Wallet {{ index + 1 }}
            <v-icon
              class="ml-2"
              @click="deleteCryptoRecord(crypto, index + 1)"
              v-if="index != 0"
            >
              mdi-delete</v-icon
            >
          </h3></v-col
        >
        <v-col cols="6">
          <label for="">Wallet Details</label>
          <v-text-field
            v-model="crypto.wallet_detail"
            maxlength="51"
            color="#434343"
            outlined
            placeholder="Enter Wallet Details"
            label=""
            dense
            name="paymentcrypto_currency_wallet_details"
            id="payment_crypto_currency_wallet_details"
          ></v-text-field>
        </v-col>

        <v-col cols="6">
          <label for="">Crypto Currency</label>
          <v-text-field
            v-model="crypto.crypto_currency"
            maxlength="51"
            color="#434343"
            outlined
            placeholder="Enter Crypto Currency"
            label=""
            dense
            name="payment_crypto_currency_type"
            id="payment_crypto_currency_type"
          ></v-text-field>
        </v-col>
      </v-row>
      <div class="d-block">
        <v-icon @click="addCrypto()"> mdi-plus-thick </v-icon>
      </div>
      <v-form ref="formBankInfo">
        <v-row
          class="ma-0"
          v-for="(bank, index) in banking_information"
          :key="index"
        >
          <v-col cols="12" class="text-center"
            ><h3 style="color: #434343" class="mb-5">
              Banking Information {{ index + 1 }}
              <v-icon
                class="ml-2"
                @click="deleteBanking(bank)"
                v-if="index != 0"
              >
                mdi-delete</v-icon
              >
            </h3></v-col
          >
          <v-col cols="4">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for="">Bank Name <span class="red--text"><strong>* </strong></span></label>
            <v-text-field
              color="#434343"
              outlined
              placeholder="Enter Bank Name"
              :rules="TextRules"
              maxlength="51"
              v-model="bank.bank_name"
              label=""
              dense
              name="payment_payment_info_bank_name"
              id="payment_payment_info_bank_name"
            ></v-text-field>
          </v-col>

          <v-col cols="4">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for="">Bank Street Address <span class="red--text"><strong>* </strong></span></label>
            <v-text-field
              color="#434343"
              outlined
              placeholder="Enter Bank Street Address  "
              :rules="TextRules"
              maxlength="51"
              v-model="bank.bank_address"
              label=""
              dense
              name="payment_payment_info_bank_street_address"
              id="payment_payment_info_bank_street_address"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for="">Bank City <span class="red--text"><strong>* </strong></span></label>
            <v-text-field
              color="#434343"
              outlined
              placeholder="Enter Bank City"
              :rules="TextRules"
              maxlength="51"
              v-model="bank.bank_city"
              label=""
              dense
              name="payment_payment_info_bank_city"
              id="payment_payment_info_bank_city"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for="">Bank Country <span class="red--text"><strong>* </strong></span></label>
            <v-text-field
              color="#434343"
              outlined
              placeholder="Enter Bank Country"
              :rules="TextRules"
              maxlength="51"
              v-model="bank.bank_country"
              label=""
              dense
              name="payment_payment_info_bank_country"
              id="payment_payment_info_bank_country"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for="">Swift <span class="red--text"><strong>* </strong></span></label>
            <v-text-field
              color="#434343"
              outlined
              placeholder="Enter Swift"
              :rules="TextRules"
              maxlength="51"
              v-model="bank.SWIFT"
              label=""
              dense
              name="payment_payment_info_swift"
              id="payment_payment_info_swift"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <label for="">IBAN (IF EU)</label>
            <v-text-field
              color="#434343"
              outlined
              placeholder="Enter IBAN (IF EU)"
              maxlength="51"
              v-model="bank.iban"
              label=""
              dense
              name="payment_payment_info_iban"
              id="payment_payment_info_iban"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for="">Name of Account <span class="red--text"><strong>* </strong></span></label>
            <v-text-field
              color="#434343"
              outlined
              placeholder="Enter Name of Account"
              :rules="TextRules"
              maxlength="51"
              v-model="bank.account_name"
              label=""
              dense
              name="payment_payment_acc_name"
              id="payment_payment_acc_name"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for="">Account No <span class="red--text"><strong>* </strong></span></label>
            <v-text-field
              color="#434343"
              outlined
              placeholder="Enter Account No"
              :rules="TextRules"
              maxlength="51"
              v-model="bank.account_number"
              label=""
              dense
              type="number"
              name="payment_payment_acc_n0"
              id="payment_payment_acc_n0"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <div class="d-block">
        <v-icon @click="addBank()"> mdi-plus-thick </v-icon>
      </div>

      <v-btn
        color="#434343"
        dark
        @click="checkForm()"
        class="mb-2 float-end"
      >
        Submit
      </v-btn>
      <v-btn text @click="updateIndex(4)" class="float-end  adjust-pre-btn mb-2 mr-1">
        Previous
      </v-btn>
    </v-container>
        <!-- Error Snackbar -->
    <v-snackbar style="z-index:999" top centered v-model="snackbarError">
      {{ this.errorText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbarError = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!-- Confirmation Dialog Box -->
    <v-dialog v-model="dialog" width="500" :persistent="true">
      <v-card>
        <v-card-title class="text-h5 red--text">
          Confirmation
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5">
          Are you sure you want to submit application form, 
          you will not be able to edit it again.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            :disabled="submitBtn == true"
            @click="(dialog = false), (loader = false)"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#434343"
            text
            @click="updatePaymentInstructions()"
            :loading="loader"
          >
            Yes, proceed to document panel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "PaymentInstructions",
  data() {
    return {
      snackbarError: false,
      loader: false,
      errorText: "",
      submitBtn: false,
      TextRules: [(v) => !!v || "Required"],
      deleteCryptoID: "",
      deleteBankID: "",
      dialog: false,
      crypto_currency_wallet: [
        // {
        //   crypto_currency_form_id: this.$store.getters.getCryptoID,
        //   form_id: 1,
        //   wallet_detail: "",
        //   crypto_currency: ""
        // }
      ],

      banking_information: [
        // {
        //   form_id: 1,
        //   key: Date.now(),
        //   bank_name: "",
        //   bank_address: "",
        //   bank_city: "",
        //   bank_country: "",
        //   swift: "",
        //   iban: "",
        //   account_name: "",
        //   account_number: ""
        // }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "getCryptoID", "getUserId", "getFormId",
      "getCorporateInfo",
      "getPrimaryContact",
      "getFinancialContact",
      "getTechnicalContact",
      "getDirectorsDetails",
      "getShareholdersDetails",
      "getBusinessProfile",
      "getTransactionalProfile",
      "getWebsiteDetails",
      "getWebsiteContent",
      "getCryptoCurrencyWallet",
      "getBankingInformation",
      "getCorporateName",
      "getSelectedFile",
      "getCorporateInfoError",
      "getPrimaryContactError",
      "getDirectorsDetailsError",
      "getShareholdersDetailsError",
      "getBusinessProfileError",
      "getWebsiteDetailsError",
      "getWebsiteContentError",
      "getPaymentInstructionsError",
      "getBankingInformationError",
      "getTransactionalProfileError",
      "getStepperCount",
      "getDocument"
    ])
  },
  methods: {
    checkForm() {
      if (
        this.getCorporateInfoError ||
        this.getPrimaryContactError ||
        this.getShareholdersDetailsError ||
        this.getDirectorsDetailsError ||
        this.getTransactionalProfileError ||
        this.getBusinessProfileError
      ) {
        this.errorText = "Please fill all the required fields";
        this.snackbarError = true;
        this.loader = false;
        this.dialog = false;
        return;
      }else{
        console.log('dasda')
      }
      this.dialog = true;
    },

    deleteCryptoRecord(crypto, index) {
      this.crypto_currency_wallet.filter(item => {
        if (item.id == crypto.id) {
          this.deleteCryptoID = crypto.id;
        }
      });
      axios
        .post(
          "/deleteCrypto",
          {
            id: this.deleteCryptoID
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          this.getNewCryptoRecord();
        })
        .catch(err => {
          console.log(err, "deleted err");
        });
    },
    // delete banking record
    deleteBanking(bank) {
      this.banking_information.filter(item => {
        if (item.id == bank.id) {
          this.deleteBankID = bank.id;
        }
      });

      axios
        .post(
          "/deleteBankingInformation",
          {
            id: this.deleteBankID
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          this.getNewBanking();
        })
        .catch(err => {
          console.log(err, "deleted err");
        });
    },
    // get new crypto record
    // getNewCryptoRecord() {
    //   axios
    //     .post(
    //       "/cryptoCurrencyWallet",
    //       {
    //         user_id: this.getUserId,
    //         form_id: this.getFormId
    //       },
    //       {
    //         headers: {
    //           Authorization: "Bearer " + localStorage.getItem("token")
    //         }
    //       }
    //     )
    //     .then(res => {
    //       // console.log(res.data, "cryp mount");
    //       this.crypto_currency_wallet = res.data.cryptoCurrencyWallet;
    //     })
    //     .catch(err => {
    //       console.log(err, "cryp mount err");
    //     });
    // },
    // // get new banking info
    // getNewBanking() {
    //   axios
    //     .post(
    //       "/bankingInformation",
    //       {
    //         user_id: this.getUserId,
    //         form_id: this.getFormId
    //       },
    //       {
    //         headers: {
    //           Authorization: "Bearer " + localStorage.getItem("token")
    //         }
    //       }
    //     )
    //     .then(res => {
    //       // console.log(res.data, "bank mount");
    //       this.banking_information = res.data.bankingInformation;
    //     })
    //     .catch(err => {
    //       console.log(err, "bank mount err");
    //     });
    // },

    addCrypto() {
      return new Promise((resolve, reject) => {
        axios
          .post(
            "/createCrypto",
            {
              user_id: this.getUserId,
              form_id: this.getFormId
            },
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            resolve(res);
            // console.log(res.data, "add new cryp");
            this.crypto_currency_wallet.push(res.data.createCryptoForm);
            this.$store.commit("updateCryptoId", res.data.createCryptoForm.id);
          })
          .catch(err => {
            reject(err);
            console.log(err, "add new cryp er");
          });
      });
    },

    addBank() {
      return new Promise((resolve, reject) => {
        axios
          .post(
            "/createBankInfo",
            {
              user_id: this.getUserId,
              form_id: this.getFormId
            },
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            resolve(res);
            // console.log(res.data, "add new bank");
            this.banking_information.push(res.data.bankingForm);
            // this.$store.commit("updateCryptoId", res.data.createCryptoForm.id);
          })
          .catch(err => {
            reject(err);
            console.log(err, "add new bank er");
          });
      });
    },

    updateIndex(index) {
      this.$store.dispatch("updateIndex", index);
    },

    updatePaymentInstructions() {
      if (!this.$refs.formBankInfo.validate()) {
        this.$store.dispatch("updatePaymentInstructionsError", true);
      } else {
        this.$store.dispatch("updatePaymentInstructionsError", !true);
      }
      this.updateIndex(6);
      this.updateCryptoAndBankingInfo();
      this.$store.dispatch("incrementStepper");
      this.dialog = false;
    },

    updateCryptoAndBankingInfo() {
      // create crypto currency wallet
      axios
        .post(
          "/createCryptoCurrencyWallet",
          {
            user_id: this.getUserId,
            form_id: this.getFormId,
            cryptoCurrencyWallet: this.crypto_currency_wallet
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          // console.log(res.data, "crypto wallet");
        })
        .catch(err => {
          console.log(err, "crypto err");
        });

      // create banking info
      axios
        .post(
          "/createBankingInformation",
          {
            user_id: this.getUserId,
            form_id: this.getFormId,
            bankingInformation: this.banking_information
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          // console.log(res.data, "banking infp");
        })
        .catch(err => {
          console.log(err, "banking err");
        });
    },

  },
  mounted() {
    this.getNewCryptoRecord();
    this.getNewBanking();
    this.TextRules.push(v => v.length <= 50 || "Max 50 characters");
  }
};
</script>
<style scoped>
.adjust-pre-btn {
font-size: 11px !important;
}
</style>
